// Class: starling.filters.BlurFilter

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_filters_FragmentFilter() {return require("./../../starling/filters/FragmentFilter");}
function starling_filters_BlurEffect() {return require("./../../starling/filters/BlurEffect");}
function starling_core_Starling() {return require("./../../starling/core/Starling");}
function starling_utils_MathUtil() {return require("./../../starling/utils/MathUtil");}

// Constructor

var BlurFilter = function(blurX,blurY,resolution) {
	if(resolution == null) {
		resolution = 1.0;
	}
	if(blurY == null) {
		blurY = 1.0;
	}
	if(blurX == null) {
		blurX = 1.0;
	}
	(starling_filters_FragmentFilter().default).call(this);
	this.__blurX = Math.abs(blurX);
	this.__blurY = Math.abs(blurY);
	this.__quality = 1.0;
	this.set_resolution(resolution);
	this.set_maintainResolutionAcrossPasses(true);
}

// Meta

BlurFilter.__name__ = "starling.filters.BlurFilter";
BlurFilter.__isInterface__ = false;
BlurFilter.__super__ = (starling_filters_FragmentFilter().default);
BlurFilter.prototype = $extend((starling_filters_FragmentFilter().default).prototype, {
	process: function(painter,helper,input0,input1,input2,input3) {
		var effect = this.get_effect();
		if(this.__blurX == 0 && this.__blurY == 0) {
			effect.set_strength(0);
			return (starling_filters_FragmentFilter().default).prototype.process.call(this,painter,helper,input0);
		}
		var inTexture;
		var outTexture = input0;
		var strengthX = this.get_totalBlurX();
		var strengthY = this.get_totalBlurY();
		effect.set_quality(this.__quality);
		effect.set_direction("horizontal");
		while(strengthX > 0) {
			effect.set_strength(strengthX);
			inTexture = outTexture;
			outTexture = (starling_filters_FragmentFilter().default).prototype.process.call(this,painter,helper,inTexture);
			if(inTexture != input0) {
				helper.putTexture(inTexture);
			}
			if(strengthX <= 1) {
				break;
			} else {
				strengthX /= 2;
			}
		}
		effect.set_direction("vertical");
		while(strengthY > 0) {
			effect.set_strength(strengthY);
			inTexture = outTexture;
			outTexture = (starling_filters_FragmentFilter().default).prototype.process.call(this,painter,helper,inTexture);
			if(inTexture != input0) {
				helper.putTexture(inTexture);
			}
			if(strengthY <= 1) {
				break;
			} else {
				strengthY /= 2;
			}
		}
		return outTexture;
	},
	createEffect: function() {
		return new (starling_filters_BlurEffect().default)();
	},
	set_resolution: function(value) {
		(starling_filters_FragmentFilter().default).prototype.set_resolution.call(this,value);
		this.updatePadding();
		return value;
	},
	updatePadding: function() {
		var paddingX = this.__blurX != 0 ? (this.get_totalBlurX() * 3 + 2) / (this.get_resolution() * this.__quality) : 0;
		var paddingY = this.__blurY != 0 ? (this.get_totalBlurY() * 3 + 2) / (this.get_resolution() * this.__quality) : 0;
		this.get_padding().setTo(paddingX,paddingX,paddingY,paddingY);
	},
	get_numPasses: function() {
		if(this.__blurX == 0 && this.__blurY == 0) {
			return 1;
		} else {
			return BlurFilter.getNumPasses(this.get_totalBlurX()) + BlurFilter.getNumPasses(this.get_totalBlurY());
		}
	},
	get_totalBlurX: function() {
		return this.__blurX * (starling_core_Starling().default).get_current().get_contentScaleFactor();
	},
	get_totalBlurY: function() {
		return this.__blurY * (starling_core_Starling().default).get_current().get_contentScaleFactor();
	},
	get_blurX: function() {
		return this.__blurX;
	},
	set_blurX: function(value) {
		if(this.__blurX != value) {
			this.__blurX = Math.abs(value);
			this.updatePadding();
		}
		return value;
	},
	get_blurY: function() {
		return this.__blurY;
	},
	set_blurY: function(value) {
		if(this.__blurY != value) {
			this.__blurY = Math.abs(value);
			this.updatePadding();
		}
		return value;
	},
	get_quality: function() {
		return this.__quality;
	},
	set_quality: function(value) {
		if(this.__quality != value) {
			this.__quality = (starling_utils_MathUtil().default).clamp(value,0.1,1.0);
			this.updatePadding();
		}
		return value;
	}
});
BlurFilter.prototype.__class__ = BlurFilter.prototype.constructor = $hxClasses["starling.filters.BlurFilter"] = BlurFilter;

// Init

Object.defineProperties(BlurFilter.prototype,{ totalBlurX : { get : function () { return this.get_totalBlurX (); }}, totalBlurY : { get : function () { return this.get_totalBlurY (); }}, blurX : { get : function () { return this.get_blurX (); }, set : function (v) { return this.set_blurX (v); }}, blurY : { get : function () { return this.get_blurY (); }, set : function (v) { return this.set_blurY (v); }}, quality : { get : function () { return this.get_quality (); }, set : function (v) { return this.set_quality (v); }}, direction : { get : function () { return this.get_direction (); }, set : function (v) { return this.set_direction (v); }}, strength : { get : function () { return this.get_strength (); }, set : function (v) { return this.set_strength (v); }}});

// Statics

BlurFilter.getNumPasses = function(blur) {
	var numPasses = 1;
	while(blur > 1) {
		++numPasses;
		blur /= 2;
	}
	return numPasses;
}


// Export

exports.default = BlurFilter;